<template>
  <live-hedging-block
    v-if="hasData"
    :has-border="true"
    :title-size="12"
    :override-title-size="true"
    :title-icon="'true'"
    :title-icon-size="7"
    :title-margin-top="'4px'"
  />
</template>

<script>
import LiveHedgingBlock from '@/theme/default/views/dashboard/blocks/LiveHedgingBlock'
import API                               from '@/api/Api'
import { clone }                         from '@/lib/utils/helper'
import DashboardHedgingPositionsResource from '@/api/resources/dashboard/DashboardHedgingPositionsResource'

export default {
  name      : 'HedgingPositions',
  components: {
    LiveHedgingBlock
  },
  dataStore: {
    hedgingPositionsData: 'Dashboard.HedgingPositions.Data'
  },
  props: {
    hasBorder: {
      type   : Boolean,
      default: true
    },
    titleSize: {
      type   : [Number, String],
      default: 12
    },
    overrideTitleSize: {
      type   : Boolean,
      default: false
    },
    titleIcon: {
      type   : String,
      default: ''
    },
    titleMarginTop: {
      type   : String,
      default: ''
    }
  },
  data () {
    return {}
  },
  computed: {
    accountId () {
      return this.user?.selectedAccountId || null
    },
    hasData () {
      return this.hedgingPositionsData?.Items?.length > 0
    }
  },
  created () {
    this.getData()
  },
  methods: {
    getData () {
      API.Resource.Positions.PositionsDashboard(this.accountId)
        .then(response => {
          this.handleResponse(response)
        })
        .catch(e => {
          this.handleResponse(e.response)
        })
        .finally(() => {})
    },
    handleResponse (response) {
      const data = API.responseData(response)?.positionsDashboard || null
      const errors = API.responseErrors(response) || []

      if (API.isResponseSuccess(response) && data) {
        const o = clone(data)
        this.$set(this, 'hedgingPositionsData', new DashboardHedgingPositionsResource(o))
      } else {
        this.$bus.$emit('app:error', errors)
      }
    }
  }
}
</script>

<style scoped>
</style>
